import React from 'react';
import { Field, ErrorMessage } from 'formik';

export const StepTwo = (errors) => (
  <div className="w-full max-w-md mx-auto p-6 bg-white shadow-md rounded-md step2">
    {/* <h6 className=" font-bold mb-6">Employment Status</h6> */}

    <div className="mb-6 form-radio2-main">
      <label htmlFor="still-employed" className="block text-gray-700 font-medium mb-2">
        Are you still employed? <span>*</span>
      </label>
      <div className="space-y-2">
        <div className="flex items-center form-radio2">
          <Field
            type="radio"
            id="employmentStatusYes"
            name="still-employed"
            value="E"
            className="mr-2"
          />
          <label htmlFor="employmentStatusYes">Yes</label>
        </div>
        <div className="flex items-center form-radio2">
          <Field
            type="radio"
            id="employmentStatusemploymentStatus"
            name="still-employed"
            value="Rd"
            className="mr-2"
          />
          <label htmlFor="employmentStatusemploymentStatus">No (Dismissed)</label>
        </div>
        <div className="flex items-center form-radio2">
          <Field
            type="radio"
            id="employmentStatusNoResigned"
            name="still-employed"
            value="T"
            className="mr-2"
          />
          <label htmlFor="employmentStatusNoResigned">No (Resigned)</label>
        </div>
        <ErrorMessage name="still-employed" component="div" className="required-text" />
      </div>
    </div>

    <div className="mb-6 form-radio2-main">
      <label className="block text-gray-700 font-medium mb-2">
        Years employed <span>*</span>
      </label>
      <div className="space-y-2">
        <div className="flex items-center form-radio2">
          <Field
            type="radio"
            id="yearsEmployedLessThan2"
            name="years-employed"
            value="2y"
            className="mr-2"
          />
          <label htmlFor="yearsEmployedLessThan2">Less than 2 years</label>
        </div>
        <div className="flex items-center form-radio2">
          <Field
            type="radio"
            id="yearsEmployedMoreThan2"
            name="years-employed"
            value="M2y"
            className="mr-2"
          />
          <label htmlFor="yearsEmployedMoreThan2">More than 2 years</label>
        </div>
        <ErrorMessage name="years-employed" component="div" className="required-text" />
      </div>
    </div>
  </div>
);

export default StepTwo;
